export default __webpack_public_path__ + "assets/images/cc240e33e40b5bab165a7ec6030cc0e3.png";